export default __webpack_public_path__ + "static/media/back.f2fdbbb2.webm";